import { useEffect, useRef, useState } from "react";
import socketIOClient from "socket.io-client";
import { config as url } from "../../common/config";
import { DecodedJWT } from "../../utils";

const useSocket = (ns, channel) => {
	const Decoded = DecodedJWT();

	const [messages, setMessages] = useState(); // Sent and received messages
	const socketRef = useRef();

	const sendMessages = (tipe, data) =>
		socketRef.current.emit(channel, { data, tipe: tipe });

	useEffect(() => {
		// if (token) {
		socketRef.current = socketIOClient(url.server + ns, {
			query: { id: Decoded.id },
		});

		// socketRef.current.emit("trigger_notif", { id: Decoded.id });

		// Listens for incoming messages
		socketRef.current.on("trigger_notif", (message) => setMessages(message));

		// Destroys the socket reference
		// when the connection is closed
		return () => {
			socketRef.current.disconnect();
		};
		// }
		// eslint-disable-next-line
	}, []);
	return { messages, sendMessages };
};

export default useSocket;
